import React, { useEffect, useState } from "react";

import "./EditCampaign.css";
import {
  Button,
  Form,
  Row,
  Spin,
  Typography,
} from "../../common/utils/antd-imports/AntdImports";
import FloatingInput from "../../common/float-input/FloatInput";
import { useDispatch, useSelector } from "react-redux";
import { renameCampaignName } from "../../../store/thunks/buyer-thunks/BuyerThunks";

const EditCampaign = ({ editCampaign, setEditCampaign, campaign }) => {
  const dispatch = useDispatch();
  const [camapaignName, setCampaignName] = useState({
    campaign_id: campaign?.campaign_id || campaign?.id,
    name: "",
  });
  const { isLoading, isRenamingLoading } = useSelector(
    (state) => state.buyerCampaigns,
  );

  const star = <span style={{ color: "#d2042d" }}>*</span>;
  const floatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.5rem",
  };
  const handleDuplicateCampaign = (e) => {
    const payload = {
      campaign_id: camapaignName?.campaign_id,
      name: camapaignName?.name,
    };
    dispatch(renameCampaignName(payload)).then((res) => {
      if (res?.payload?.status == 1) {
        setEditCampaign(false); // Reset editing mode
      }
    }); // Dispatch here when Enter is pressed
  };
  const { Text } = Typography;

  // Update campaign_id when campaignId prop changes
  useEffect(() => {
    setCampaignName((prev) => ({
      ...prev,
      campaign_id: campaign?.campaign_id || campaign?.id,
      name: campaign?.campaign_name,
    }));
  }, [campaign]);
  return (
    <>
      <div>
        <Row>
          <Text className="share-camapign-model-header">Edit Campaign</Text>
        </Row>
        <Form onSubmitCapture={handleDuplicateCampaign}>
          <Form.Item name="name">
            <Row>
              <FloatingInput
                label={
                  <>
                    {`Edit your campaign name`}
                    {star}
                  </>
                }
                customStyles={floatingInputStyles}
                value={camapaignName?.name}
                onChange={(e) =>
                  setCampaignName({
                    ...camapaignName,
                    name: e.target.value
                      ?.replace(/[\\/]/g, "")
                      ?.replace(/\s{2,}/g, " "),
                  })
                }
                className="billboard-input-feild"
              />
            </Row>
          </Form.Item>
          <Row justify="end">
            <Button
              className="billboard-buttons billboard-button-1"
              style={{ marginRight: "0.5rem" }}
              onClick={(e) => {
                setEditCampaign(false);
              }}
            >
              Cancel
            </Button>
            <Button
              className={`billboard-buttons billboard-button-2 ${
                !camapaignName?.name ? "disabled-opacity" : ""
              }`}
              htmlType="submit"
              disabled={!camapaignName?.name}
            >
              Save
            </Button>
          </Row>
        </Form>
      </div>
      {isLoading ||
        (isRenamingLoading && (
          <div className="loading-css">
            <Spin size="large" fullscreen />
          </div>
        ))}
    </>
  );
};

export default EditCampaign;
